import{ useMemo, useState } from "react";

import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { useMasReport } from "./MasReport/useMasReport";
import { showToast } from "../../utils/toastUtils";
import { useGetOrgUnitsData } from "../FSM/Beats_Patches/hooks/useBeat";
import { COLORS } from "../../constants/colors";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import { getMasReport } from "./MasReport/MasReportRepo";

const MasReport = () => {
  const {startPolling} = useExcelPolling();
  const getLastSixMonths = (): { id: string; label: string }[] => {
    const months: { id: string; label: string }[] = [];
    const today = new Date();

    for (let i = 0; i < 12; i++) {
      const year = today.getFullYear();
      const month = today.getMonth() - i;
      const date = new Date(year, month, 1);
      const start = new Date(date.getFullYear(), date.getMonth(), 1);
      const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);

      const startStr = start.toLocaleDateString("sv-SE");
      const endStr = end.toLocaleDateString("sv-SE");
      const label = `${date.toLocaleString("default", {
        month: "short",
      })} ${String(date.getFullYear()).slice(2)}`;
      months.push({
        id: `${startStr}|${endStr}`,
        label,
      });
    }

    return months;
  };

  const months = useMemo(() => getLastSixMonths(), []);
  const [monthForAPI, setMonthForAPI] = useState("");
  const [filterData, setFilterData] = useState<any>({ start: 1, length: 10 });
  const [endDate, setEmdDate] = useState("");
  const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });
  const [division, setdivision] = useState(null);
  const [apiSearch, setApiSearch] = useState("");
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading.");

  const {
    data: MasReprtData,
    isLoading,
    isSuccess,
  } = useMasReport({
    enable: !!monthForAPI || !!division || !!apiSearch,
    param: {
      ...(apiSearch === "" ? {} : { search: apiSearch }),
      ...(division === null ? {} : { division_id: division }),
      ...(monthForAPI === "" ? {} : { start_date: monthForAPI }),
      ...(endDate === "" ? {} : { end_date: endDate }),
      start: filterData.start,
      length: filterData.length,
      action: "view",
    },
  });

  const downloadExcelGet = async () => {
    const param= {
      ...(apiSearch === "" ? {} : { search: apiSearch }),
      ...(division === null ? {} : { division_id: division }),
      ...(monthForAPI === "" ? {} : { start_date: monthForAPI }),
      ...(endDate === "" ? {} : { end_date: endDate }),
      start: filterData.start,
      length: filterData.length,
      action: "download",
    }
    try {
          setLoadingExcel(true);
          const response = await getMasReport(param);
          const { success, fileDownloadId, intervalTime } =
            response.rowData.data || {};
          if (success && fileDownloadId) {
            startPolling(fileDownloadId, intervalTime, {
              onStatusUpdate: (excelStatus: string) => {
                setExcelStatus(excelStatus);
              },
              onSuccess: (url:string) => {
                setLoadingExcel(false);
                setExcelStatus('Loading..');
                const a = document.createElement('a');
                a.href = url;
                a.download = 'report.xlsx';
                a.click();
                showToast.success('The file is ready!');
              },
              onFaled:(message:string)=>showToast.error(message ||"onFalied error in Mas  report excel"),
              onExpired:(message:string)=>showToast.error(message||"onExpired error in  Mas report excel"),
              onDeleted:(message:string)=>showToast.error(message || "onDeleted error in Mas report excel ")
            });
          }
        } catch (error: any) {
          console.log("Error while downloading excel in Mas report");
        }
  };

  // console.log('monthForAPI',monthForAPI);
  const handleSearch = (input: any) => {
    setApiSearch(input);
  };

  const hadleMonth = (value: any) => {
    const monthstring = value.id;
    const foramtedMonth = monthstring.split("|")[0];
    setMonthForAPI(foramtedMonth);
  };

  const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
    }));
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      start: pageNo,
      length: limit,
    }));
  };

  return (
    <div className="p-2">
      <PageHeader
        title="MAS Report"
        buttons={[
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  ".."
                : ""
              : "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />
      <BasicDataTable
        SearchPlaceholder="Search by employee,code"
        filterFirstApporach={
          monthForAPI == "" && division === null && apiSearch == ""
            ? false
            : true
        }
        Title="MAS Report"
        dynamicHeightOnRowsPerPage={true}
        data={(!isLoading && isSuccess && MasReprtData?.formatedData) || []}
        columns={MasReportColoumn}
        handleSearch={(text: any) => handleSearch(text)}
        headerContent={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
              marginBottom: "15px",
            }}
          >
            <RoundedDropdown
              options={orgUnitsList?.data || []}
              onSelect={(e: any) => setdivision((prev: any) => e.id)}
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Division"
              headingColor="#2e8dd3"
            />
            {/* Month Dropdown */}
            <RoundedDropdown
              options={months || []}
              onSelect={(e) => hadleMonth(e)}
              defaultLabel="Select"
              width="120px"
              isShowHeading
              DropdownHeading="Month"
              headingColor="#2e8dd3"
            />
          </div>
        }
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        paginationTotalRows={MasReprtData?.rowData.data?.recordsTotal || 0}
      />
    </div>
  );
};
const MasReportColoumn = [
  {
    name: "Org Unit",
    selector: (row: { orgunit: string }) => (row.orgunit ? row.orgunit : "-"),
    sortable: true,
    width: "180px",
  },
  {
    name: "Rep Code",
    selector: (row: { repcode: string }) => (row.repcode ? row.repcode : "-"),
    sortable: true,
    width: "180px",
  },
  {
    name: "Employee Code",
    selector: (row: { employeecode: string }) =>
      row.employeecode ? row.employeecode : "-",
    sortable: true,
    width: "160px",
  },
  {
    name: "Employee Name",
    selector: (row: { employeename: string }) =>
      row.employeename ? row.employeename : "-",
    sortable: true,
    width: "160px",
    wrap: true,
  },
  {
    name: "AM Name",
    selector: (row: { amname: string }) => (row.amname ? row.amname : "-"),
    sortable: true,
    width: "180px",
  },
  {
    name: "RM Name",
    selector: (row: { rmname: string }) => (row.rmname ? row.rmname : "-"),
    sortable: true,
    width: "180px",
  },
  {
    name: "ZM Name",
    selector: (row: { zmname: string }) => (row.zmname ? row.zmname : "-"),
    sortable: true,
    wrap: true,
    width: "180px",
  },
  {
    name: "Location",
    selector: (row: { location: string }) =>
      row.location ? row.location : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Working Days",
    selector: (row: { workingdays: string }) =>
      row.workingdays ? row.workingdays : "-",
    sortable: true,
    width: "160px",
  },
  {
    name: "FWD",
    selector: (row: { fwd: string }) => (row.fwd ? row.fwd : "-"),
    sortable: true,
  },
  {
    name: "NCA",
    selector: (row: { nca: string }) => (row.nca ? row.nca : "-"),
    sortable: true,
  },
  {
    name: "Total Doctors",
    selector: (row: { totaldoctors: string }) =>
      row.totaldoctors ? row.totaldoctors : "-",
    sortable: true,
    width: "160px",
  },
  {
    name: "Dr Met",
    selector: (row: { drmet: string }) => (row.drmet ? row.drmet : "-"),
    sortable: true,
  },
  {
    name: "Dr VF Met",
    selector: (row: { drvfmet: string }) => (row.drvfmet ? row.drvfmet : "-"),
    sortable: true,
    width: "120px",
  },
  {
    name: "Drca L",
    selector: (row: { drcal: string }) => (row.drcal ? row.drcal : "-"),
    sortable: true,
  },
  {
    name: "Drcvrg",
    selector: (row: { drcvrg: string }) => (row.drcvrg ? row.drcvrg : "-"),
    sortable: true,
  },
  {
    name: "Drvforvg",
    selector: (row: { drvforvg: string }) =>
      row.drvforvg ? row.drvforvg : "-",
    sortable: true,
    width: "120px",
  },
  {
    name: "Missed Dr",
    selector: (row: { misseddr: string }) =>
      row.misseddr ? row.misseddr : "-",
    sortable: true,
    width: "120px",
  },
  {
    name: "Missed Dr Calls",
    selector: (row: { misseddrcalls: string }) =>
      row.misseddrcalls ? row.misseddrcalls : "-",
    sortable: true,
    width: "160px",
  },
  {
    name: "Total Chemist",
    selector: (row: { totalchemist: string }) =>
      row.totalchemist ? row.totalchemist : "-",
    sortable: true,
    width: "160px",
  },
  {
    name: "POB Value",
    selector: (row: { pobvalue: string }) =>
      row.pobvalue ? row.pobvalue : "-",
    sortable: true,
  },
  {
    name: "RCPA Own Brand",
    selector: (row: { rcpaownbrand: string }) =>
      row.rcpaownbrand ? row.rcpaownbrand : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "RCPA Comp Brand",
    selector: (row: { rcpacompbrand: string }) =>
      row.rcpacompbrand ? row.rcpacompbrand : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Joint Work Total Calls",
    selector: (row: { jointworktotalcalls: string }) =>
      row.jointworktotalcalls ? row.jointworktotalcalls : "-",
    sortable: true,
    width: "200px",
  },
  {
    name: "Leave Days",
    selector: (row: { leavedays: string }) =>
      row.leavedays ? row.leavedays : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Joint Working",
    selector: (row: { jointworking: string }) =>
      row.jointworking ? row.jointworking : "-",
    sortable: true,
    width: "160px",
  },
  {
    name: "No Dr Call",
    selector: (row: { nodrcall: string }) =>
      row.nodrcall ? row.nodrcall : "-",
    sortable: true,
    width: "200px",
  },
  {
    name: "Agenda",
    selector: (row: { agenda: string }) => (row.agenda ? row.agenda : "-"),
    sortable: true,
    wrap: true,
  },
  {
    name: "ZM Position Code",
    selector: (row: { zmpositioncode: string }) =>
      row.zmpositioncode ? row.zmpositioncode : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "RM Position Code",
    selector: (row: { rmpositioncode: string }) =>
      row.rmpositioncode ? row.rmpositioncode : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "AM Position Code",
    selector: (row: { ampositioncode: string }) =>
      row.ampositioncode ? row.ampositioncode : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Employee Status",
    selector: (row: { employeestatus: string }) =>
      row.employeestatus ? row.employeestatus : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Employee Position Code",
    selector: (row: { employeepositioncode: string }) =>
      row.employeepositioncode ? row.employeepositioncode : "-",
    sortable: true,
    width: "220px",
  },
  {
    name: "Employee Position Name",
    selector: (row: { employeepositionname: string }) =>
      row.employeepositionname ? row.employeepositionname : "-",
    sortable: true,
    width: "220px",
  },
  {
    name: "Employee Level",
    selector: (row: { employeelevel: string }) =>
      row.employeelevel ? row.employeelevel : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Chemist Met",
    selector: (row: { chemistmet: string }) =>
      row.chemistmet ? row.chemistmet : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Chemist Calls",
    selector: (row: { chemistcalls: string }) =>
      row.chemistcalls ? row.chemistcalls : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Chemist Call Avg",
    selector: (row: { chemistcallavg: string }) =>
      row.chemistcallavg ? row.chemistcallavg : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Total Stockist",
    selector: (row: { totalstockist: string }) =>
      row.totalstockist ? row.totalstockist : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Dr Addition",
    selector: (row: { draddition: string }) =>
      row.draddition ? row.draddition : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Dr Deletion",
    selector: (row: { drdeletion: string }) =>
      row.drdeletion ? row.drdeletion : "-",
    sortable: true,
    width: "180px",
  },
];

export default MasReport;
